import { render, staticRenderFns } from "./terminosCondiciones.vue?vue&type=template&id=4a30c3a0&scoped=true"
import script from "./terminosCondiciones.vue?vue&type=script&lang=js"
export * from "./terminosCondiciones.vue?vue&type=script&lang=js"
import style0 from "./terminosCondiciones.vue?vue&type=style&index=0&id=4a30c3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a30c3a0",
  null
  
)

export default component.exports